import { render, staticRenderFns } from "./SingleImage.vue?vue&type=template&id=6ddf8551&"
import script from "./SingleImage.vue?vue&type=script&lang=js&"
export * from "./SingleImage.vue?vue&type=script&lang=js&"
import style0 from "./SingleImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports